const stylesNavbar = {
  appBar: {
    display: "flex",
    overflow: "hidden",
    position: "fixed",
    width: '100vw',
    height:"3.9rem",
    backgroundColor: "transparent",
    transition: "background-color 0.3s",
    boxShadow: "none",
    fontFamily: "Raleway, sans-serif",
  },
  appBarScrolling: {
    backgroundColor: "white",
    boxShadow: "",
  },
  textBlue: {
    fontSize: "22px",
    fontWeight:"bold",
    textDecoration: "none",
    color: "white",
    transition: "background-color 0.3s",
    fontFamily: "Raleway, sans-serif",
  },
  textBlueScrolling: {
    color: "#0979b0",
    fontFamily: "Raleway, sans-serif",
  },
  stack: {
    margin: "1rem",
    marginTop:"14px",
    '@media (max-width: 1243px)': {
      margin: "1rem",
      marginLeft: "2rem",
    },
  },
  a: {
    fontSize: "17px",
    textDecoration: "none",
    color: "white",
    transition: "background-color 0.3s",
    padding: "3px 3px",
    fontFamily: "Raleway, sans-serif",
    '@media (max-width: 1243px)': {
      fontSize: "1px",
      padding: "0.5rem 1rem",
    },
  },
  aHover: {
    color: "#0c4a91ff",
  },
  b: {
    fontSize: "17px",
    textDecoration: "none",
    color: "white",
    transition: "background-color 0.3s",
    padding: "0.3rem 3px",
    
    fontFamily: "Raleway, sans-serif",
    '@media (max-width: 1243px)': {
      fontSize: "6px",
      padding: "0.3rem 1rem",
    },
  },
  aScrolling: {
    color: "black",
    fontWeight:"500",
  },
};

export default stylesNavbar;